import { SetStateAction } from "react";
import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import secureLocalStorage from "react-secure-storage";
import { saveCustomerRecordFields } from "../functions/saveCustomerRecordFields";

export const docFieldsModal = ({
  t,
  saveAccess,
  modalData,
  setModalData,
  logoutAction,
  closeMsg,
}: stdObject) => {
  return "recordsFields" in modalData
    ? {
        title: t("p.fields"),
        inputs: modalData.recordsFields.map((e: stdObject, index: number) => {
          return {
            label: e.label,
            value: e.value,
            type: "checkbox",
            style: { width: 300 },
            onChange: (v: { target: { value: SetStateAction<string> } }) => {
              let tempData = modalData;
              tempData.recordsFields[index].value = Number(v.target.value)
                ? 0
                : 1;
              secureLocalStorage.setItem(
                "docRecFields",
                tempData.recordsFields.reduce(
                  (acc: stdObject, curr: stdObject) => {
                    if (!curr.value) {
                      acc.push(curr.code);
                    }
                    return acc;
                  },
                  [],
                ),
              );
              setModalData({ ...tempData });
            },
          };
        }),
        buttons: [
          {
            label: t("p.apply"),
            onClick: () => {
              modalData.setRecordFields({
                ...modalData.recordsFields.reduce(
                  (acc: stdObject, curr: stdObject) => {
                    acc[curr.code] = curr.value;
                    return acc;
                  },
                  {},
                ),
              });
              closeMsg();
              setModalData({});
            },
            color: colors.green,
          },
          saveAccess === 3 && {
            label: t("p.save"),
            onClick: () => {
              saveCustomerRecordFields(
                modalData.recordsFields
                  .filter((e: stdObject) => !e.value)
                  .map((e: stdObject) => e.code),
                logoutAction,
              );

              closeMsg();
              setModalData({});
            },
            color: colors.blue,
          },
          {
            label: t("p.cancel"),
            onClick: () => {
              closeMsg();
            },
            color: colors.darkGrey,
          },
        ],
      }
    : {};
};
